<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="800px">
            <v-toolbar class="headline" color="primary" dark>物件グループ名</v-toolbar>
            <v-form ref="buildDialogForm" v-model="valid" lazy-validation>
                <v-card class="parkselect" outlined>
                    <v-row class="delBtn">
                        <ryou-del-btn v-show="showDelBtn" class="btnDel" :handlerClick="groupHandledDelete">
                        </ryou-del-btn>
                    </v-row>
                    <v-row class="groupInput">
                        <v-col cols="12" sm="6" md="5">
                            <ryou-input v-model="model.build_group_name" :value="model.build_group_name"
                                :label="'物件グループ名'" :rules="buildGroupRules" :maxlength="15">
                            </ryou-input>
                        </v-col>
                        <v-col cols="12" sm="6" md="5">
                            <ryou-input v-model="model.meal_deadline" :value="model.meal_deadline" :label="'食事締め切り日'"
                                :rules="mealRules" :maxlength="1">
                            </ryou-input>
                        </v-col>
                    </v-row>
                    <v-row class="btnPadding">
                        <v-spacer></v-spacer>
                        <ryou-black-btn :label="'閉じる'" :handlerClick="handleCancel" :iconCls="'mdi-close'">
                        </ryou-black-btn>
                        <v-spacer></v-spacer>
                        <ryou-black-btn :label="'登録'" :handlerClick="handleOk"></ryou-black-btn>
                        <v-spacer></v-spacer>
                    </v-row>
                </v-card>
            </v-form>
        </v-dialog>
        <ryou-confirm ref="confirm"></ryou-confirm>
    </v-row>
</template>

<script>
    import RyouInput from "@/components/formInput/RyouInput.vue";
    import RyouDelBtn from "@/components/formInput/RyouDelBtn.vue";
    import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
    import RyouConfirm from "@/components/dialog/RyouConfirm.vue";
    export default {
        name: "MasterBuildGroupDialog",
        components: {
            RyouInput,
            RyouDelBtn,
            RyouBlackBtn,
            RyouConfirm,
        },
        mounted() {
            this.buildGroupRules.push(this.GlobalRules.required);
            this.mealRules.push(this.GlobalRules.required);
            this.mealRules.push(this.GlobalRules.number);
        },
        props: {
            loadFlag: {
                type: Boolean,
                required: false,
                default: true,
            },
        },
        data: () => ({
            dialog: false,
            valid: true,
            selectGroup: "",
            buildGroupId: "",
            buildGroupRules: [],
            mealRules: [],
            model: {
                build_group_name: "",
                meal_deadline: "",
            },
        }),
        computed: {
            showDelBtn() {
                if (this.loadFlag == true) {
                    return true;
                } else {
                    return false;
                }
            },
        },
        methods: {
            add() {
                this.open();
                this.title = "物件グループ新規";
                this.buildGroupUpdateFlg = false;
            },
            edit(record) {
                this.open();
                this.title = "物件グループ更新";
                this.buildGroupUpdateFlg = true;
                this.buildGroupId = record;
                this.buildGroupInfoGet(record);
            },
            //物件グループ情報取得
            buildGroupInfoGet(record) {
                let params = {
                    build_group_id: record,
                };
                this.getRequest("/masterProperty/buildGroupDetailGet", params, this.$store.getters.getUserToken).then(
                    (data) => {
                        if (data.success) {
                            this.model.build_group_name = data.result[0].build_group_name;
                            this.model.meal_deadline = data.result[0].meal_deadline;
                        }
                    }
                );
            },
            //物件グループ削除
            groupHandledDelete() {
                var that = this;
                let params = {
                    loginUserId: this.$store.getters.getUserId,
                    build_group_id: this.buildGroupId,
                };
                this.$refs.confirm
                    .open("削除", "削除します。宜しいですか？", { color: "blue" })
                    .then((confirm) => {
                        if (confirm) {
                            this.deleteRequest("/masterProperty/buildGroupDelete", params, this.$store.getters.getUserToken).then(
                                (res) => {
                                    if (res.success) {
                                        that.$emit("ok");
                                        that.close();
                                    }
                                }
                            );
                        }
                    });
                setTimeout(() => { }, 100);
            },
            handleOk() {
                var valid = this.$refs.buildDialogForm.validate();
                if (valid) {
                    var that = this;
                    if (this.buildGroupUpdateFlg) {
                        this.$refs.confirm
                            .open("更新", "更新します。宜しいですか？", { color: "info" })
                            .then((confirm) => {
                                if (confirm) {
                                    let updateParams = {
                                        loginUserId: this.$store.getters.getUserId,
                                        build_group_id: this.buildGroupId,
                                        build_group_name: this.model.build_group_name,
                                        meal_deadline: this.model.meal_deadline,
                                    };
                                    this.putRequest(
                                        "/masterProperty/buildGroupUpdate",
                                        updateParams,
                                        this.$store.getters.getUserToken
                                    ).then((resp) => {
                                        if (resp.success) {
                                            that.$emit("ok");
                                        }
                                    });
                                }
                            });
                    } else {
                        this.$refs.confirm
                            .open("登録", "登録します。宜しいですか？", { color: "info" })
                            .then((confirm) => {
                                if (confirm) {
                                    let insertParams = {
                                        loginUserId: this.$store.getters.getUserId,
                                        build_group_name: this.model.build_group_name,
                                        meal_deadline: this.model.meal_deadline,
                                    };
                                    this.postRequest(
                                        "masterProperty/buildGroupInsert/",
                                        insertParams,
                                        this.$store.getters.getUserToken
                                    ).then((resp) => {
                                        if (resp.success) {
                                            that.$emit("ok");
                                        }
                                    });
                                }
                            });
                    }
                }
            },
            handleCancel() {
                this.close();
            },
            close() {
                this.dialog = false;
                this.buildGroupId = "";
            },
            open() {
                this.dialog = true;
                if (this.$refs.buildDialogForm) {
                    this.$refs.buildDialogForm.reset();
                    this.$refs.buildDialogForm.resetValidation();
                }
            },
        },
    };
</script>

<style scoped>
    .parkselect {
        padding: 20px;
        height: 240px;
    }

    .btnPadding {
        padding-top: 5%;
    }

    .delBtn {
        height: 50px;
        padding-top: 10px;
    }

    .groupInput {
        height: 70px;
    }

    .btnDel {
        position: absolute;
        right: 25px;
    }
</style>